import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DvButtonComponent, DvDialogContent, DvDialogContentComponent } from '@devinco/ui/dds';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-purchase-success-dialog',
  imports: [DvDialogContentComponent, DvButtonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './purchase-success-dialog.component.html',
})
export class PurchaseSuccessDialogComponent extends DvDialogContent<
  undefined,
  PurchaseSuccessDialogComponent
> {}
